import { cn } from "@core-ui/utils/cn";
import { useHorizontalScrollShadow } from "@ui-kit/ScrollShadowContainer";
import { type ReactNode, useCallback, useRef } from "react";

type Props = {
	className?: string;
	children: ReactNode;
};

export const AttachmentRow = ({ className, children }: Props) => {
	const rowRef = useRef<HTMLDivElement>(null);
	const getRow = useCallback(() => rowRef.current, []);
	useHorizontalScrollShadow(getRow);

	return (
		<div className={cn("overflow-x-auto", className)} ref={rowRef}>
			<div className="flex w-max items-start gap-1.5">{children}</div>
		</div>
	);
};
